import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api, { setToken, getToken } from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    if (!getToken()) { setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes('session_id=')) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const register = async (email, password, name) => {
    const { data } = await api.post('/auth/register', { email, password, name });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const googleLogin = async (sessionId) => {
    const { data } = await api.post('/auth/google/session', {}, { headers: { 'X-Session-ID': sessionId } });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    setToken(null); setUser(null);
  };
  const refresh = checkAuth;

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, googleLogin, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}
